import React from 'react';

import { ClientReportingMicroFrontend } from './ClientReportingPayoutsMFE';

export const ReportPreview = () => (
  <ClientReportingMicroFrontend
    portalSection="reports"
    dataFd="client-reporting-preview-micro-frontend"
  />
);

export default ReportPreview;
